// extracted by mini-css-extract-plugin
module.exports = {"activeOff":"changeComponent_activeOff__d17ia","wrapField":"changeComponent_wrapField__2q1Qq","disabled":"changeComponent_disabled__178L3"};